module.exports = __webpack_public_path__ + "static/media/click-setup.6545e67f.gif";